import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useGlobalErrorsStore = defineStore('globalErrors', () => {
	const error = ref<string | null>(null)
	const timezone = ref<string | undefined>(undefined)
	const isError = ref(false)

	const setError = (err: string, time?: string) => {
		error.value = err
		timezone.value = time
		isError.value = true
	}

	const clearError = () => {
		error.value = null
		isError.value = false
		timezone.value = undefined
	}

	return {
		error,
		timezone,
		isError,
		setError,
		clearError,
	}
})
